import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useReloadPageOnLanguageChange = (enabled: boolean) => {
  const { i18n } = useTranslation()

  const callbackFn = useCallback(() => {
    if (enabled) {
      i18n.on('languageChanged', () => window.location.reload())
    }

    return () => i18n.off('languageChanged')
  }, [i18n, enabled])

  useEffect(() => {
    callbackFn()
  }, [callbackFn])
}
